import axios from 'axios';

export default class RegulationsSetsService
{
    public static async getList(filter: FilterModel, pager: Pager)
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>('admin/cms/regulations/sets', {
            params: { ...filter, ...pager.data() }
        })).data;
    }

    public static async getAll()
    {
        return (await axios.get<Resource<ListItemModel[]>>('admin/cms/regulations/sets/all')).data;
    }

    public static async getForWebsite(websiteId: number, locale: string)
    {
        return (await axios.get<Option[]>(`admin/cms/regulations/sets/${websiteId}/${locale}`)).data;
    }

    public static async remove(id: number)
    {
        return (await axios.delete(`admin/cms/regulations/sets/${id}`)).data as Statement;
    }

    public static async fetch(id: number)
    {
        return (await axios.get<Resource<ViewModel>>(`admin/cms/regulations/sets/${id}`)).data;
    }

    public static async create(model: FormModel)
    {
        return (await axios.post<Resource<ViewModel>>(`admin/cms/regulations/sets`, model)).data;
    }

    public static async update(id: number, model: FormModel)
    {
        return (await axios.put<Resource<ViewModel>>(`admin/cms/regulations/sets/${id}`, model)).data;
    }
}

export interface FilterModel
{
    name: string;
    type: string;
    language: string;
}

export interface FormModel
{
    id: number;
    type: string;
    name?: string;
    language: string;
    regulations: number[];
    websiteId: number;
    isRequiredAfterChanges: boolean;
}

export interface ViewModel
{
    id: number;
    type: string;
    name?: string;
    language: string;
    regulations: KeyValue<number, string>[];
    websiteId: number;
    isRequiredAfterChanges: boolean;
}

export interface ListItemModel
{
    id: number;
    type: string;
    name?: string;
    language: string;
    regulations: string[];
}
